import React from 'react';

interface DateDividerProps {
  date: string;
}

const getRelativeTime = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  
  if (diffInDays === 0) {
    return 'Today';
  } else if (diffInDays === 1) {
    return 'Yesterday';
  } else if (diffInDays < 30) {
    return `${diffInDays} days ago`;
  } else {
    const diffInMonths = Math.floor(diffInDays / 30);
    return diffInMonths === 1 ? '1 month ago' : `${diffInMonths} months ago`;
  }
};

const styles = {
  dateHeader: {
    margin: '16px 0 8px',
    position: 'relative' as const,
    textAlign: 'center' as const,
  },
  dateDivider: {
    padding: '6px 12px',
    backgroundColor: '#e5e5e5',
    borderRadius: '16px',
    display: 'inline-block',
    fontSize: '14px',
    fontWeight: 500 as const,
    color: '#555',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
  },
};

export const DateDivider: React.FC<DateDividerProps> = ({ date }) => {
  const relativeTime = getRelativeTime(date);
  const formattedDate = new Date(date).toLocaleDateString('en-US', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
  
  return (
    <div style={styles.dateHeader}>
      <div style={styles.dateDivider}>
        {formattedDate} ({relativeTime})
      </div>
    </div>
  );
}; 